<template>
    <div class="main_menu_container">
        <NotificationBar></NotificationBar>
        <div class="menu_image_container" @click="() => openMenu()">
            <MenuIcon />
        </div>
        <div class="main_menu_black_wrapper" @click="() => closeMenu()" v-if="state.isMenuOpened === true" />
        <div class="main_menu_content_container" :class="{'show': state.showMenu === true, 'hide': state.showMenu === false}" v-if="state.isMenuOpened === true" id="menu_content_container">
            <p class="main_menu_link" @click="() => onClickHandler('/welcomeback')">Home page</p>
            <div class="notifications_hl_container">
                <p class="main_menu_link" @click="() => onClickHandler('/notifications')">Notifications</p>
                <!-- <div class="notifications_hl_counter">5</div> [ATD-836] remove the 5 from the Notification on the Main Menu -->
                <div class="notifications_hl_counter" v-if="state.notificationsCounter > 0 ">{{state.notificationsCounter}}</div>
            </div>
            <p class="main_menu_link" @click="() => onClickHandler('/contactsupport')">Contact Support/Restart diary</p>
            <a href="https://touchpoints.ipsos.com/" @click="() => updateSurveyWebsiteCount()" style="text-decoration: none;" target="_blank"><p class="main_menu_link">About TouchPoints</p></a>
            <a href="https://touchpoints.ipsos.com/how-to-videos" @click="() => updateHowToVideosCount()" style="text-decoration: none;" target="_blank"><p class="main_menu_link">How to videos</p></a>
            <a href="https://touchpoints.ipsos.com/faqs/" @click="() => updateFAQsCount()" style="text-decoration: none;" target="_blank"><p class="main_menu_link">FAQs</p></a>
            <p class="main_menu_link" @click="() => onClickHandler('/privacy')">Privacy</p>
            <p class="main_menu_link" @click="() => onClickHandler('/termsandconditions')">Terms and Conditions</p>
            <p class="main_menu_link logout_button" @click="() => logOut()">Logout</p>
            <p class="main_menu_link version_title">Version {{ JSON.parse(packVer).version }}</p>
        </div>
    </div>
</template>

<script setup lang="ts">

    import { onMounted, reactive, ref } from 'vue';
    import MenuIcon from '../images/MenuIcon.vue';
    import { useRouter } from 'vue-router';
    //import { getDays } from '../../use/useTouchpointsHTTP';
    //import { IStatusDay } from '../../interfaces/status-day.interface';
    import { appStatus } from '../../use/useAppStatus';
    import NotificationBar from '../../components/PushNotification/NotificationBar.vue';
    import { useTouchpointsHTTP } from '../../use/useTouchpointsHTTP';

    
    const packVer = JSON.stringify(require('../../../package.json'));

    console.log(JSON.parse(packVer).version);

    const state = reactive({
        isMenuOpened: false,
        showMenu: false,
        drag: false,
        notificationsCounter: 0
    });
    // eslint-disable-next-line
    const router = useRouter();

    const notificationData = ref(
        JSON.parse(localStorage.getItem('notificationData') || '[]').sort((a: { time: number; }, b: { time: number; }) => b.time - a.time)
    );

    onMounted(() => {
        //[Optimize API usage]-remove unused API call
        /*
        const username = window.localStorage.getItem("username")!;
        getDays(username).then((data) => {
            const result: IStatusDay[] = data!.data;
            // eslint-disable-next-line
            let completetedDays = 0;
            result.forEach((day) => {
                if(day.is_complete) {
                    completetedDays += 1;
                }
                // comeplete diary logic -> to be built
            });
        })
        */

        // notificationData.value.forEach((content: { viewed: boolean; }) => {
        //     if (content.viewed == false) {
        //         state.notificationsCounter++;
        //     } 
        // });

    })

    function onClickHandler(route: string) {
        if(route =='/privacy' || route== '/termsandconditions'){
            appStatus.hideAcceptAndRejectBTN = true;
        }         
        router.push(route);
        closeMenu();
    }

    function logOut() {
        window.localStorage.removeItem("userId")
        window.localStorage.removeItem("touchPointsLastLogin")
        window.localStorage.removeItem("username")
        window.localStorage.removeItem("touchPointsAuth")
        window.localStorage.removeItem("diaryStartDate")
        window.localStorage.removeItem("privacyAgree")
        window.localStorage.removeItem("trainingAgree")
        window.localStorage.removeItem("sleepTaskAgree")
        window.localStorage.removeItem("termAgree")
        window.localStorage.removeItem("dummyTimeslot")
        window.localStorage.removeItem("notificationData")
        window.localStorage.removeItem("termVer")
        window.localStorage.removeItem("pageReload")
        // window.localStorage.removeItem("checked_for_reset")
        window.localStorage.removeItem("fromWelcomePage")
        window.localStorage.removeItem("openedQuestion")
        window.localStorage.removeItem("fromTraining")
        window.localStorage.removeItem("privacyVer")
        window.localStorage.removeItem("subscription")
        window.localStorage.removeItem("PUBLIC_VAPID_KEY")
        window.localStorage.removeItem("current_timeslot_updated")
        window.localStorage.removeItem("diaryStarted")
        window.localStorage.removeItem("diaryStartDate")
        window.localStorage.removeItem("diaryId")
        window.localStorage.removeItem("session_id");
        location.reload(); // page need to be reloaded to clear cache after logout. [ATD-760]
        router.push({name: 'login'});
    }

    function removeMenuOnDrag(iteration: number, posDiff: number, element: HTMLElement) {
        if(posDiff - iteration >= -400) {
            iteration = iteration + 10;
            element.style.right = `${-posDiff-iteration}px`
            setTimeout(() => {
                removeMenuOnDrag(iteration, posDiff, element);
            }, 1);
        }
        else {
            state.isMenuOpened = false;
            return iteration;
        }
    }

    function regetMenuOnDrag(iteration: number, posDiff: number, element: HTMLElement) {
        if(-posDiff + iteration <= 0) {
            iteration = iteration + 5;
            element.style.right = `${(-posDiff + iteration) <= 0 ? -posDiff + iteration : 0}px`
            setTimeout(() => {
                regetMenuOnDrag(iteration, posDiff, element);
            }, 1);
        }
        else {
            return iteration;
        }
    }

    function openMenu() {
        if(state.isMenuOpened === false) {

            useTouchpointsHTTP().count_main_menu_clicks(localStorage.getItem("username")!);

            notificationData.value = JSON.parse(localStorage.getItem('notificationData') || '[]').sort((a: { time: number; }, b: { time: number; }) => b.time - a.time);

            notificationData.value.forEach((content: { viewed: boolean; }) => {
                if (content.viewed == false) {
                    state.notificationsCounter++;
                } 
            });         

            state.isMenuOpened = true
            state.showMenu = true
            setTimeout(() => {
                // eslint-disable-next-line
                let drag = false;
                let mousedown = false;
                let initialPos: number;
                let posDiff: number;
                const menu = document.getElementById("menu_content_container");
                menu?.classList.remove("show");
                menu?.addEventListener("touchstart", (event) => {
                    drag = false;
                    initialPos = event.changedTouches[0].screenX;
                    posDiff = 0;
                });
                if(window.innerWidth < 1000) {
                    menu?.addEventListener("touchmove", (event) => {
                    drag = true;
                    posDiff = event.changedTouches[0].screenX - initialPos;
                    if(posDiff <= 400 && posDiff >= 0) {
                        menu.style.right = `${-posDiff}px`;
                    }
                    });
                    menu?.addEventListener("touchend", () => {
                        initialPos = 0;
                        if(posDiff >= 145) {
                            removeMenuOnDrag(0, posDiff, menu);
                        }
                        else {
                            regetMenuOnDrag(0, posDiff, menu);
                        }
                    });
                }
                menu?.addEventListener('mousedown', (event) => {
                    drag = false;
                    mousedown = true;
                    initialPos = event.screenX;
                    posDiff = 0;
                });
                menu?.addEventListener('mousemove', (event) => {
                    drag = true;
                    if(mousedown) {
                        posDiff = event.screenX - initialPos;
                        if(posDiff <= 400 && posDiff >= 0) {
                            menu.style.right = `${-posDiff}px`;
                        }
                    }
                });
                menu?.addEventListener('mouseup', () => {
                    mousedown = false;
                    initialPos = 0;
                    if(posDiff >= 80) {
                        removeMenuOnDrag(0, posDiff, menu);
                    }
                    else {
                        regetMenuOnDrag(0, posDiff, menu);
                    }
                });
            }, 500);
        }
    }

    function closeMenu() {
        if(state.isMenuOpened === true) {
            state.showMenu = false
            setTimeout(() => {
                state.isMenuOpened = false
            }, 500);
        }
    }
    
    function updateSurveyWebsiteCount() {
        useTouchpointsHTTP().count_survey_web_hplk_clicks(localStorage.getItem("username")!);
    }

    function updateHowToVideosCount() {
        useTouchpointsHTTP().count_how_video_clicks(localStorage.getItem("username")!);
    }

    function updateFAQsCount() {
        useTouchpointsHTTP().count_faq_clicks(localStorage.getItem("username")!);
    }

</script>

<style scoped>

    .main_menu_container {
        width: 100%;
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 16px;
        padding-right: 16px;
        position: fixed;
        bottom: 0px;
        background-color: #F6F6F6;
    }

    .menu_image_container {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        
    }

    .main_menu_black_wrapper {
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0px;
        top: 0px;
        background-color: rgba(0, 0, 0, 0.193);
    }

    @keyframes menuIn {
        from {
            right: -400px;
        }
        to {
            right: 0px;
        }
    }
    @keyframes menuOut {
        from {
            right: 0px;
        }
        to {
            right: -400px;
        }
    }

    .main_menu_content_container {
        position: fixed;
        width: 100%;
        max-width: 350px;
        background-color: white;
        right: 0px;
        top: 0px;
        height: 100%;
        display: flex;
        flex-direction: column;
        padding-top: 100px;
        padding-left: 32px;
        border-top: 1px solid #efefef;
        overflow-y: scroll;
    }

    .main_menu_content_container.show {
        animation-name: menuIn;
        animation-timing-function: ease-in-out;
        animation-duration: 0.3s;
        animation-fill-mode: forwards;
    }
    .main_menu_content_container.hide {
        animation-name: menuOut;
        animation-timing-function: ease-in-out;
        animation-duration: 0.3s;
        animation-fill-mode: forwards;
    }

    .main_menu_link {
        font-family: 'Karla';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0.02em;
        color: #4A4A49;
        flex: none;
        order: 0;
        flex-grow: 0;
        margin-bottom: 25px;
        cursor: pointer;
    }

    .main_menu_link.version_title {
        cursor: default !important;
    }

    .logout_button {
        height: 60px;
        margin-top: auto;
        display: flex;
        align-items: flex-end;
    }
    

    .notifications_hl_container {
        display: flex;
        align-items: center;
        width: 100%;
        margin-top: 16px;
        margin-bottom: 25px;
    }

    .notifications_hl_container .main_menu_link {
        margin: 0px !important;
    }

    .notifications_hl_counter {
        width: 24px;
        height: 24px;
        background-color: #655A95;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 100%;
        color: white;
        padding-top: 2px;
        padding-bottom: 2px;
        padding-left: 4px;
        padding-right: 4px;
        font-size: 14px;
        font-weight: bold;
        margin-left: 10px;
    }
</style>